import { DetailEditEntityDialog } from '@/features/shared/components/entityDetails/DetailEditEntityDialog';
import { suiteRunStatusOptions } from '@/shared/constants/statusOptions';
import type { TagColor } from '@/shared/data/tags';
import type { SuiteRunDto } from '@flowqa/shared';
import type { ReactElement } from 'react';

type SuiteRunEditDialogProps = {
  open: boolean;
  execution: SuiteRunDto | null;
  loading?: boolean;
  onClose: () => void;
  onSave: (input: {
    tags: string[];
    colors: TagColor[];
    status?: SuiteRunDto['status'];
    timestamp?: Date | null;
    durationMs?: number | null;
  }) => Promise<void> | void;
};

export const SuiteRunEditDialog = ({
  open,
  execution,
  loading = false,
  onClose,
  onSave,
}: SuiteRunEditDialogProps): ReactElement => {
  const title = execution?.suiteName?.trim() ?? execution?.name?.trim() ?? execution?.id ?? '';

  return (
    <DetailEditEntityDialog
      open={open}
      entityLabel="Suite Run"
      entityName={title}
      entityRunNumber={execution?.runNumber ?? null}
      projectId={execution?.projectId ?? null}
      tags={execution?.tags ?? []}
      status={execution?.status}
      timestamp={execution?.timestamp ?? null}
      durationMs={execution?.durationMs ?? null}
      durationLabel="Duration"
      durationInputMode="timeParts"
      statusOptions={suiteRunStatusOptions}
      loading={loading}
      cascadeCopy="Tags will be applied to all associated test runs."
      onClose={onClose}
      onSave={onSave}
    />
  );
};
